import React from 'react'
import EightRooms from '../components/EightRooms'

class IndexPage extends React.Component {
  render() {
    const songData = this.props.data.allWordpressWp8Rooms.edges
    const pageData = this.props.data.allWordpressPage.edges[0].node
    return <EightRooms songList={songData} pageData={pageData} />
  }
}

export default IndexPage

// Set here the ID of the home page.
export const pageQuery = graphql`
  query eightRoomsQuery {
    allWordpressWp8Rooms {
      edges {
        node {
          title
          wordpress_id
          acf {
            is_active
            poster {
              source_url
            }
            popup_content {
              video_link
              film_maker_statement
              stills {
                source_url
              }
              lyrics
            }
          }
        }
      }
    }

    allWordpressPage(filter: { wordpress_id: { eq: 22 } }) {
      edges {
        node {
          content
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/8-rooms.js